import src from "IMAGE";
export default { src, width: 940, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AFV7WglVe1kKV3xbDVl+XhJYfV0RWX5dDV6CYhZihWYap3MKLNfAF94AAAAASUVORK5CYII="};
